module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data.length) ? _c('div', {
    class: [_vm.name, _vm.flat ? (_vm.name + "-flat") : null],
    attrs: {
      "id": _vm.id
    }
  }, [(_vm.title) ? _c('div', {
    class: [(_vm.name + "-title")],
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: [(_vm.name + "-container")]
  }, [(_vm.donut) ? _c('div', {
    class: [(_vm.name + "-donut")]
  }) : _vm._e()]), _vm._v(" "), (_vm.legend) ? _c('ul', {
    class: [(_vm.name + "-legend")]
  }, _vm._l((_vm.data), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('span', {
      style: ({
        background: item.color
      })
    }), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.label(item))
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), _c('vc-style', [_vm._v("\n  #" + _vm._s(_vm.id) + ",\n  #" + _vm._s(_vm.id) + " ." + _vm._s(_vm.name) + "-container\n  {\n    width: " + _vm._s(_vm.size) + ";\n  }\n\n  #" + _vm._s(_vm.id) + " ." + _vm._s(_vm.name) + "-container\n  {\n    height: " + _vm._s(_vm.size) + ";\n  }\n\n  #" + _vm._s(_vm.id) + " ." + _vm._s(_vm.name) + "-container\n  {\n    background: " + _vm._s(_vm.segments) + ";\n  }\n\n  #" + _vm._s(_vm.id) + " ." + _vm._s(_vm.name) + "-donut\n  {\n    background: " + _vm._s(_vm.parentBgColor) + ";\n    width: calc(" + _vm._s(_vm.size) + " / 2.5);\n    height: calc(" + _vm._s(_vm.size) + " / 2.5);\n  }\n  ")])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2116e7c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vc-piechart/piechart.vue
// module id = 23
// module chunks = 2